import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { LoadingState } from '../../utils/loadingState';
import { CertificateInfo } from '@urbanx/agx-ui-components';

interface PoolCertificateState {
  loadingState: LoadingState;
  poolSafetyCertificate?: CertificateInfo | null;
  buildingCertificate?: CertificateInfo | null;
  poolSafetyCertificateDaysUntilExpiry?: number | null;
  buildingCertificateDaysUntilExpiry?: number | null;
}

const initialState = {
  loadingState: LoadingState.NotLoaded,
} satisfies PoolCertificateState as PoolCertificateState;

const slice = createSlice({
  name: 'poolDocumentation',
  initialState,
  reducers: {
    startLoadingPoolCertificate: (state) => {
      return {
        ...state,
        ...initialState,
        loadingState: LoadingState.Loading,
      };
    },
    poolCertificateLoaded: (
      state,
      action: PayloadAction<{
        poolSafetyCertificate?: CertificateInfo | null;
        buildingCertificate?: CertificateInfo | null;
        poolSafetyCertificateDaysUntilExpiry?: number | null;
        buildingCertificateDaysUntilExpiry?: number | null;
      }>
    ) => {
      return {
        ...state,
        ...action.payload,
        loadingState: LoadingState.Loaded,
      };
    },
    errorLoadingPoolCertificate: (state) => {
      return {
        ...state,
        ...initialState,
        loadingState: LoadingState.Failed,
      };
    },
    clearPoolCertificateData: (state) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export default slice.reducer;

const {
  startLoadingPoolCertificate,
  poolCertificateLoaded,
  errorLoadingPoolCertificate,
  clearPoolCertificateData,
} = slice.actions;

export {
  startLoadingPoolCertificate,
  poolCertificateLoaded,
  errorLoadingPoolCertificate,
  clearPoolCertificateData,
};
